<template>
  <span>
    <div class="dropdown" ref="dropdown" v-if="params.data.rubricVersionId && params.data.learnerBuildingLEA">
        <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="gridAction" data-bs-toggle="dropdown" aria-expanded="false">
        Action
        </button>
        <ul class="dropdown-menu grid-action-menu" ref="menu" aria-labelledby="gridAction">
            <li v-if="choices.length == 1 && params.data.defaultObserverUserId && !params.data.isAssigned" ><a class="dropdown-item" @click="onAcceptDefault">Accept </a></li>
            <li v-else><a class="dropdown-item" @click="doAssignment">Assign</a></li>
            <li v-if="this.params.data.isAssigned"><a class="dropdown-item" @click="doRemoveAssignment">Unassign</a></li>
            <li v-if="this.params.data.isHidden"><a class="dropdown-item" @click="toggleHidden(false)">Unhide Learner</a></li>
            <li v-else><a class="dropdown-item" @click="toggleHidden(true)">Hide Learner</a></li>
        </ul>
    </div>
    <span v-else>
      <span class="badge bg-danger">Configure</span>
      <button v-if="params.data.isHidden" class="btn btn-sm btn-outline-secondary ms-1" @click="toggleHidden(false)">Unhide</button>
    </span>
  </span>
</template>

<script lang="js">
import Vue from 'vue'

export default Vue.extend({
  data: function () {
    return {
      choices: 0
    }
  },
  beforeMount() {
    this.choices = this.params.infoCallback(this.params.data.learnerRoleType, this.params.data.learnerBuildingLEA, this.params.data.learnerUserId)
  },
  mounted() {
    this.$el.addEventListener('show.bs.dropdown', this.detachMenu)
    this.$el.addEventListener('hidden.bs.dropdown', this.restoreMenu)
  },
  beforeDestroy() {
    this.$el.removeEventListener('show.bs.dropdown', this.detachMenu)
    this.$el.removeEventListener('hidden.bs.dropdown', this.restoreMenu)
    this.restoreMenu()
  },
  methods: {
    // The grid's overflow clips the menu when only a few rows are shown, so render it in body while open.
    detachMenu() {
      const menu = this.$refs.menu
      if (menu && menu.parentNode !== document.body) {
        document.body.appendChild(menu)
      }
    },
    restoreMenu() {
      const menu = this.$refs.menu
      const dropdown = this.$refs.dropdown
      if (menu && dropdown && menu.parentNode === document.body) {
        dropdown.appendChild(menu)
      }
    },
    toggleHidden(hidden) {
      if (window.confirm('Are you sure you want to ' + (hidden ? 'hide' : 'unhide') + ' this learner?')) {
        this.params.data.isHidden = hidden
        this.params.context.toggleHidden(this.params.data)
      }
    },
    doAssignment() {
      this.params.context.assignmentFunction(this.params.data)
    },
    doRemoveAssignment() {
      this.params.context.removeAssignmentFunction(this.params)
    },
    onAcceptDefault() {
      this.params.acceptDefaultAssignmentCallback(this.params.data)
    }
  },
  watch: {
    'params.data': {
      handler: function (newData) {
        //console.log ('data has changed...')
        this.choices = this.params.infoCallback(this.params.data.learnerRole, this.params.data.learnerBuildingLEA)
        if (this.choices.length == 1) {
          this.params.data.defaultObserverUserId = this.choices[0].userId
        }
      },
      deep: true
    }
  }

})

</script>